import moment from 'moment';

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const ZIPCODE_REGEX = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
const SPECIAL_CHAR = /[!@#$%^&*()+=\-\[\]\\\'\;\,\/\|\"\:\<\>\?\{\}0-9]+/;

const isEmail = (value) => {
  return EMAIL_REGEX.test(value);
};

const isZipCode = (value) => {
  return ZIPCODE_REGEX.test(value);
};

const isBirthDay = (year, month, day) => {
  return moment(`${year}/${month}/${day}`, 'YYYY/M/D', true).isValid() && new Date() > new Date(year, month - 1, day);
};

const isName = value => {
  return !SPECIAL_CHAR.test(value);
};

const doesConfirmComponentMatch = (componentState, confirmComponentState) => {
  const {
    isUsed: isComponentUsed,
    isChanged: isComponentChanged,
    value: componentValue
  } = componentState;
  const {
    isUsed: isConfirmComponentUsed,
    isChanged: isConfirmComponentChanged,
    value: confirmComponentValue
  } = confirmComponentState;
  const isBothUsed = componentState
    && confirmComponentState
    && isComponentUsed
    && isConfirmComponentUsed;
  const isBothChanged = isBothUsed && isComponentChanged && isConfirmComponentChanged;

  if (!isBothUsed || !isBothChanged) {
    return true;
  }
  return componentValue === confirmComponentValue;
};

const initRules = (hint) => {
  return {
    required: {
      rule: value => {
        return value.toString().trim();
      },
      hint: () => hint('This field is required')
    },
    email: {
      rule: value => {
        return isEmail(value);
      },
      hint: () => hint('Invalid email address')
    },
    confirmEmail: {
      rule: (value, components) => {
        const {
          emailAddress: {
            state: email
          } = {},
          confirmEmail: {
            state: confirmEmail
          } = {}
        } = components;
        return doesConfirmComponentMatch(email, confirmEmail);
      },
      hint: () => hint('Email addresses do not match')
    },
    password: {
      rule: (value, components) => {
        const {
          password: {
            state: password
          } = {},
          confirmPassword: {
            state: confirmPassword
          } = {}
        } = components;
        return doesConfirmComponentMatch(password, confirmPassword);
      },
      hint: () => hint('Passwords do not match')
    },
    zipcode: {
      rule: value => {
        return isZipCode(value);
      },
      hint: () => hint('Invalid Zip Code')
    },
    birthday: {
      rule: (value, components) => {
        const {
          year: {
            state: {
              value: year
            } = {}
          } = {},
          month: {
            state: {
              value: month
            } = {}
          } = {},
          day: {
            state: {
              value: day
            } = {}
          } = {}
        } = components;

        if (year && month && day){
          return isBirthDay(year, month, day);
        } else {
          return true;
        }
      },
      hint: () => hint('Invalid Birthday')
    },
    phone: {
      rule: value => value.toString().trim().length <= 15,
      hint: () => hint('Phone number cannot exceed 15 characters')
    },
    name: {
      rule: value => isName(value.toString().trim()),
      hint: () => hint('Invalid name')
    }
  };
};

const validateEmail = (value) => {
  let messageError = '';
  if (!value) {
      messageError = 'Email address must be specified.';
  } else if (!isEmail(value)) {
      messageError = 'Email address is not valid.';
  } else if (value.length > 255){
      messageError = 'Email address cannot exceed 255 characters.';
  } else {
      messageError = '';
  }
  return messageError;
};


export { isEmail, isZipCode, isBirthDay, isName, initRules, validateEmail };



// WEBPACK FOOTER //
// ./app/utils/ValidateUtils.js